import emissionsPageData from "../../data/english/emissions-page-data";
import MainHeader from "../../layouts/MainHeader";
import EmissionsHeaderImage from '../../assets/images/wallpaper/emissions.jpg';
import ReactVisibilitySensor from "react-visibility-sensor";
import BorderLeftBox from "../../components/boxes/BorderLeftBox";
import PrimaryColoredSection from "../../components/sections/ColoredSection/PrimaryColoredSection";
import BorderCenterLabel from "../../components/Labels/BorderCenterLabel";
import Footer from "../../layouts/Footer";
import EmissionsPlan from '../../assets/images/plans/emissions.svg';
import TitleBorderLeft from "../../components/Text/TitleBorderLeft";
import Separator from "../../components/Separator";

const EmissionsPage = () => {
    return (
        <main id="main" className="page">
            <div className="sticky-view-two">
                <div className="sticky-container">
                    <MainHeader
                        image={{
                            src: EmissionsHeaderImage,
                            alt: "Solar panals"
                        }}
                        title=""
                    />
                </div>
                <div className="sticky-container-two" id="mainContent">
                    <div className="wrapper-small">
                        <h1 className={`title-center`}>{emissionsPageData.title}</h1>
                        <p className={`text-paragraph`}>{emissionsPageData.paraghraphOne}</p>
                        <p className={`text-paragrap`}>{emissionsPageData.paraghraphTwo}</p>
                        <div className="space-50"></div>
                        <Separator />
                        <div className="space-50"></div>
                        <TitleBorderLeft>{emissionsPageData.sectionOne.title}</TitleBorderLeft>
                        <div className="table-wrapper">
                            <table className="table-secondary">
                                <thead>
                                    <tr></tr>
                                    <tr>
                                        <th></th>
                                        <th className="td-e">Measure</th>
                                        <th className="td-e">2023</th>
                                        <th className="td-e">2022 (restated)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Total electricity consumption</td>
                                        <td className="td-e">kWh</td>
                                        <td className="td-e">69,099,385<sup className="red-text a-mark">&#9398;</sup></td>
                                        <td className="td-e">63,915,431*</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p className="text-note">Selected metrics marked with the <sup className="red-text a-mark">&#9398;</sup> symbol have been subject to independent limited assurance procedures by PricewaterhouseCoopers Public Accountants (‘PwC’)
                            for the year ended 2023</p>
                        <p className="text-note">*The electricity consumption data for the year ended 31 December 2022, due to improvement in data availability, has been restated from 34,941,966 kWh to 63,915,431 kWh to include
                            branches that are under our operational control.</p>

                    </div>

                    <div className="wrapper-small">
                        <BorderLeftBox
                            title={emissionsPageData.sectionTwo.title}
                            subtitle={emissionsPageData.sectionTwo.subtitle}
                        />
                        <div className="emission-plan-wrapper">
                            <img
                                src={EmissionsPlan}
                                className="emission-plan"
                                alt="a figure discripe the SAB scops"
                            />
                        </div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <p className={`text-paragraph`}>{emissionsPageData.sectionThree.description}</p>
                    </div>
                    {
                        emissionsPageData.sectionThree.labels.map((item, index) => (
                            <BorderCenterLabel
                                key={index}
                                boxes={item}
                            />
                        ))
                    }
                    <div className="space-50"></div>
                    <div className='wrapper-small'>
                        <p className="text-paragraph">{emissionsPageData.sectionThree.pargraph}</p>
                        <div className="space-50"></div>
                        <TitleBorderLeft>{emissionsPageData.sectionFour.title}</TitleBorderLeft>
                    </div>
                    {
                        emissionsPageData.sectionFour.labels.map((item, index) => (
                            <BorderCenterLabel
                                key={index}
                                boxes={item}
                            />
                        ))
                    }
                    {/* <PrimaryColoredSection 
                        card={{
                            paragraphOne : emissionsPageData.sectionFive.card.discription,
                            paragraphTwo : emissionsPageData.sectionFive.card.discriptionTwo,
                            image : {
                                src : require(`../../assets/images/cards/${emissionsPageData.sectionFive.card.image.src}`),
                                alt : emissionsPageData.sectionFive.card.image.alt,
                            }
                        }}
                        info={emissionsPageData.sectionFive.info}
                        title={emissionsPageData.sectionFive.title}
                        labels={emissionsPageData.sectionFive.labels}
                    /> */}
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="wrapper-small">
                        <BorderLeftBox
                            title={emissionsPageData.sectionSeven.title}
                        />
                        <p className="text-paragraph">{emissionsPageData.sectionSeven.paragraphOne}</p>
                        <p className="text-paragraph">{emissionsPageData.sectionSeven.paragraphTwo}</p>
                        <p className="text-paragraph">{emissionsPageData.sectionSeven.paragraphThree}</p>
                    </div>
                    <div className="wrapper-small">
                        <BorderLeftBox
                            title={emissionsPageData.sectionFive.boxOne.title}
                            subtitle={emissionsPageData.sectionFive.boxOne.subtitle}
                        />
                        <p className="text-paragraph">{emissionsPageData.sectionFive.paragraphOne}</p>
                        <p className="text-paragraph">{emissionsPageData.sectionFive.paragraphTwo}</p>
                        <TitleBorderLeft>{emissionsPageData.sectionFive.title}</TitleBorderLeft>
                    </div>
                    {
                        emissionsPageData.sectionFive.labels?.map((item, index) => (
                            <BorderCenterLabel
                                key={index}
                                boxes={item}
                            />
                        ))
                    }
                    <div className='space-50'></div>
                    <div className="wrapper-small">
                        <p className="text-note">{emissionsPageData.sectionFive.note}</p>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <PrimaryColoredSection
                        bg={2}
                        customerImageClass="customer-image-class"
                        card={{
                            image: {
                                src: require(`../../assets/images/cards/${emissionsPageData.sectionSix.card.image.name}`),
                                alt: emissionsPageData.sectionSix.card.image.alt,
                            }
                        }}
                        info={emissionsPageData.sectionSix.info}
                        title={emissionsPageData.sectionSix.title}
                        labels={emissionsPageData.sectionSix.labels}
                    />
                    <div className="wrapper-small">
                        <p className="text-note">{emissionsPageData.sectionSix.note}</p>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <Footer withBlogs={false} />
                </div>
            </div>

        </main>
    )
}

export default EmissionsPage